import { Edit, Visibility } from '@mui/icons-material'
import { Container, Grid, Paper, Typography } from '@mui/material'
import { useGetUsersQuery, useUserUpdateMutation } from 'api/adminSlice'
import { omitBy,cloneDeep, set, omit  } from 'lodash'
import { DataTable, SearchTextFiled } from 'modules/common'
import moment from 'moment/moment'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import UserDialog from './UserDialog'

const $COLUMN_WIDTH = 200
export default function AdminUsers() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [params, setParams] = useState({
    page: 1,
    limit: 100,
    searchKey: ''
  })
  const [
    userUpdate,
    {
      isLoading: updateUserLoading,
      isSuccess: updateUserIsSuccess,
      error: updateUserError,
      reset: updateReset,
    },
  ] = useUserUpdateMutation();
  const [selectedUser, setSelectedUser] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    currentStatus: "",
  });
  const resetSelectedUser = () => {
    setSelectedUser({id:"", firstName: "",lastName:"", email: "", phone: "", currentStatus: "" });
  };

  const handleChange = ({ target: { value, name } }) => {
    setSelectedUser((prevState) => {
      let payload = cloneDeep(prevState);
      payload= set(payload, name, value);
      return payload;
    });
  };
  const [openUserDialog, setOpenUserDialog] = useState(false);
  const openDialogForEditUser = (data) => {
    updateReset();
    const user = cloneDeep(data);
    setSelectedUser(user);
    setOpenUserDialog(true);
  };

  const { data: users, isLoading: usersLoaing, isFetching, refetch } = useGetUsersQuery(omitBy(params, v => !v))

  const pageChangeHandler = ({ page }) => {
    if (!isFetching) {
      setParams((prevParams) => ({ ...prevParams, page }))
    }
  }

  //=============Search by text handlers=============
  const timerRef = useRef(null)
  const [searchKey, setSearchKey] = useState('')
  const onSearchKeyChange = ({ target: { value } }) => {
    setSearchKey(value)
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setParams((prevParams) => ({ ...prevParams, searchKey: value }))
    }, 1000);
  }

  //=================Data tables================= 

  const NameCell = ({ row }) => (
    <Typography>
      {`${row?.firstName} ${row?.lastName}`}
    </Typography>
  )
  const ActionsCell = ({ row }) => (
    <>
       <Visibility aria-label="view" onClick={() => navigate(`/admin/user/${row?.id}`)} sx={{ mr: 5 }} />
    
      <Edit aria-label="edit" 
        onClick={() => openDialogForEditUser(row)}
         />
   </>
  )
  const PhoneCell = ({ value }) => (
    <Typography>
      <bdi>{value ? value.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3') : ''}</bdi>
    </Typography>
  )
  const StatusCell = ({ value }) => (
    <Typography color={value === "ACTIVE" ? "success.main" : value === "BLOCKED" ? "error" : "warning.main"} sx={{ fontWeight: "bold" }}>
      {t(`UserStatus.${value}`)}
    </Typography>
  )
  const closeDialogHandler = () => {
    setOpenUserDialog(false);
    resetSelectedUser();
  };

  //============== User CRUD Handlers ==============
  const updateUserHandler = async (payload) => {
    const [firstName, lastName] = payload.fullName.split(" ");



    let newData = omit(payload, ['fullName', 'id','status']);
    newData = { ...newData, firstName, lastName,currentStatus: payload.status};
    console.log(newData);

    const response = await userUpdate({id:payload.id, payload:newData}).unwrap();
    console.log(response);
    if (response?.success) {
      refetch();
      closeDialogHandler();
    }
  };

  const columns = [
    { field: "name", renderCell: NameCell, sortable: false, headerName: t("Full Name"), width: $COLUMN_WIDTH * 1.1 },
    { field: "email", sortable: false, headerName: t("Email"), width: $COLUMN_WIDTH * 1.2, },
    { field: "phone", renderCell: PhoneCell, sortable: false, headerName: t("Phone"), width: $COLUMN_WIDTH * 1 },
    { field: "currentStatus", renderCell: StatusCell, sortable: false, headerName: t("Status"), width: $COLUMN_WIDTH * 1 },
    { field: "createdAt", valueGetter: ({ value }) => moment(value).format("DD/MM/YY - h:mm A"), sortable: false, headerName: t("Created At"), width: $COLUMN_WIDTH * 0.8 },
    { field: "Actions", renderCell: ActionsCell, sortable: false, headerName: t("Actions"), width: $COLUMN_WIDTH *1.1}
  ];

  return (
    <Container>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ my: 25 }} spacing={10}>
        <Grid item md={4} sm={4} xs={12}>
          <Typography variant='h6'>{t("Users")}</Typography>
        </Grid>
        <Grid item md={5} sm={7} xs={12}>
          <SearchTextFiled
            fullWidth
            label={t("Search")}
            size="small"
            value={searchKey ?? ''}
            onChange={onSearchKeyChange}
          />
        </Grid>
      </Grid>
      <Paper sx={{ height: "78vh" }}>
        <DataTable
          rows={users?.docs ?? []}
          columns={columns}
          onPaginationModelChange={pageChangeHandler}
          paginationModel={{ page: params.page - 1, pageSize: 100 }}
          rowCount={users?.totalDocs ?? 0}
          loading={usersLoaing || isFetching}
        />
      </Paper>
      <UserDialog
        openUserDialog={openUserDialog}
        loading={updateUserLoading}
        isEditing={true} // Always true since we're only editing
        user={selectedUser}
        handleChange={handleChange}
        onUpdateUser={updateUserHandler}
        onCloseDialog={closeDialogHandler}
        error={updateUserError}
        isSuccess={updateUserIsSuccess}
      />
    </Container>
  )
}
